var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab-item',[_c('v-container',[_c('panel-customer'),_c('panel-contract'),(_vm.refs.modules.data.isBilling)?_c('panel-payment'):_vm._e(),(_vm.refs.modules.data.isInsurance)?_c('panel-product'):_vm._e(),_c('panel-complementary')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }